import styled from "styled-components";

const BtnArea = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 10px;
	@media print {
		button {
			display: none;
		}
	}
`;
const SubTitle = styled.h4`
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	margin-top: 40px;
	margin-bottom: 20px;
	line-height: 1;
	font-size: var(--medium-size);
	color: var(--emp-color);
	> p {
		margin-bottom: 0;
	}
`;
const ExpensesTable = styled.table`
	width: 100%;
	border-top: 1px solid var(--emp-color);
	th {
		height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid var(--line-color);
		background: var(--disabled-color);
		color: var(--emp-color);
		text-align: center;
		vertical-align: middle;
		&:not(:last-child) {
			border-right: 1px solid var(--line-color);
		}
	}
	tbody {
		width: 100%;
	}
`;
const ExpensesTd = styled.td<{line?: boolean; align?: string}>`
	height: inherit;
	padding: 7px 0;
	padding-right: ${props => (props.align ? "10px" : "0")};
	border-right: 1px solid var(--line-color);
	border-bottom: ${props => (props.line ? "1px solid var(--line-color)" : "0")};
	font-size: var(--default-size);
	text-align: ${props => (props.align ? props.align : "center")};
	vertical-align: middle;
	color: var(--default-color);
	em {
		font-size: var(--medium-size);
	}
	&:last-child {
		border-right: 0;
	}
`;
const ProductTitle = styled.strong`
	font-size: var(--medium-size);
	font-weight: normal;
	color: var(--emp-color);
`;
const RadioList = styled.ul`
	display: flex;
	> li + li {
		margin-left: 20px;
	}
`;
const BulletList = styled.ul`
	margin-top: 10px;
	> li {
		line-height: 24px;
		font-size: var(--default-size);
		&::before {
			top: 10px;
		}
	}
	@media print {
		li {
			font-size: var(--medium-size);
		}
	}
`;
const TableInfoText = styled.p`
	margin-bottom: 20px;
	line-height: 1;
	font-size: var(--basic-size);
	text-align: right;
	em {
		color: var(--blue-color);
	}
`;
const InfoText = styled.p`
	font-size: var(--small-size);
`;
const LocationText = styled.p`
	padding: 15px;
	text-align: left;

	@media print {
		padding: 5px;
	}
`;

const EditorWrap = styled.div`
	margin-top: 10px;
`;

export {
	BulletList,
	ExpensesTable,
	ExpensesTd,
	InfoText,
	ProductTitle,
	RadioList,
	SubTitle,
	TableInfoText,
	styled,
	BtnArea,
	LocationText,
	EditorWrap,
};
